import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="performances--vacation-pattern"
export default class extends Controller {
  static values = {
    date: String,
    vacationPatternId: Number,
    vacationTimeSliceId: { type: Number, default: null },
    vacationTime: { type: Number, default: null }
  }

  connect() {
    const row = this.element.closest("tr.attendance-row")
    this.dispatch("updated", {
      detail: { date: this.dateValue, row: row, vacationPatternId: this.vacationPatternIdValue, vacationTimeSliceId: this.vacationTimeSliceIdValue, vacationTime: this.vacationTimeValue }
    })
  }
}
